import React from 'react';

import { YesNo } from '../components/inputs';

function PlanConf() {
  return (
    <div>
      <YesNo
        label="Plan Confirmation"
        name="planconf"
      />
    </div>
  );
}

export default PlanConf;
